import {
  resolveRelatedShapeFeatureId,
  syncPersistedSqftShapeFeature,
} from "./syncPersistedSqftShapeFeature";

const getLinkedSQFTIds = (cartItem) => {
  const ids = Array.isArray(cartItem.sqftIds) ? cartItem.sqftIds : [];
  return cartItem.sqftId === undefined || cartItem.sqftId === null
    ? ids
    : [...ids, cartItem.sqftId];
};

// Keeps persisted calculator shapes aligned with a feature replacement in the cart.
export const syncCartFeatureToSqftCalcData = (quotes, oldCartItem, updatedCartItem, layout = null) => {
  const oldFeatureId = oldCartItem?.cartFeature?.dbFeature?.id;
  const updatedFeatureId = updatedCartItem?.cartFeature?.dbFeature?.id;
  const linkedSQFTIds = getLinkedSQFTIds(updatedCartItem || {});

  if (!oldFeatureId || !updatedFeatureId
    || String(oldFeatureId) === String(updatedFeatureId)
    || linkedSQFTIds.length === 0) {
    return quotes;
  }

  const quoteIndex = Number(updatedCartItem.currentQuote);
  const quote = quotes[quoteIndex];
  if (!quote || !Array.isArray(quote.sqFtCalcData?.countertops)) {
    return quotes;
  }

  const linkedSQFTIdSet = new Set(linkedSQFTIds.map(id => String(id)));
  let hasChanges = false;
  const countertops = quote.sqFtCalcData.countertops.map(countertop => {
    if (!linkedSQFTIdSet.has(String(countertop.id))) {
      return countertop;
    }

    const updatedCountertop = syncPersistedSqftShapeFeature(countertop, {
      featureId: updatedFeatureId,
      oldFeatureId,
      partId: updatedCartItem.partId,
      shapeFeatureId: resolveRelatedShapeFeatureId(
        countertop,
        updatedCartItem.cartFeature,
        layout,
        oldCartItem.cartFeature
      ),
    });
    hasChanges = hasChanges || updatedCountertop !== countertop;
    return updatedCountertop;
  });

  if (!hasChanges) {
    return quotes;
  }

  const updatedQuotes = [...quotes];
  updatedQuotes[quoteIndex] = {
    ...quote,
    sqFtCalcData: {
      ...quote.sqFtCalcData,
      countertops,
    },
  };
  return updatedQuotes;
};
